import React from 'react';
import { useTranslation } from '../../../shared/i18n/translate/useTranslation';
import { HashDialog } from '../../../shared/components/dialog/HashDialog';
import { DeleteAccountDialogContent } from './DeleteAccountDialogContent';

export const DELETE_ACCOUNT_DIALOG_HASH = '#delete-account';

export const DeleteAccountDialog = () => {
	const { t } = useTranslation();

	return (
		<HashDialog
			ariaLabel={t('user_delete_account_label')}
			hash={DELETE_ACCOUNT_DIALOG_HASH}
		>
			<DeleteAccountDialogContent />
		</HashDialog>
	);
};
